/**
 * @generated SignedSource<<ca783751b4d87b53aeba3faaaa9059dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "achConfirmDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AchConfirmUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountTPayload",
        "kind": "LinkedField",
        "name": "updateAccountTByAccountId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AchConfirmUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountTPayload",
        "kind": "LinkedField",
        "name": "updateAccountTByAccountId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "27141273c37cd5778c74d0ff68c76730",
    "id": null,
    "metadata": {},
    "name": "AchConfirmUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AchConfirmUpdateMutation(\n  $input: UpdateAccountTByAccountIdInput!\n) {\n  updateAccountTByAccountId(input: $input) {\n    accountT {\n      accountId\n      accountName\n      achConfirmDate\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "692d6d2bbc78879819d8297adac4be06";

module.exports = node;
